module.exports = __webpack_public_path__ + "assets/e4697db279f4fc1ef83acacb23fc5096.png";